@if (true) {
  <div class="wrap"
    >
    @if (component.headline && component.copy) {
      <div class="center"
        >
        <div class="w-8 w-12-m w-12-s pos-center">
          <!-- headline -->
          <h2 class="m-t-8"
            sizeClass="!S: h1, S: h2"
          *iCms="'headline' of component; skipEmpty: true"></h2>
          <!-- copy -->
          <div class="m-t-10 m-t-4-s"
            sizeClass="!S: o1, S: p1"
          *iCms="'copy' of component; content: 'html'; skipEmpty: true"></div>
        </div>
      </div>
    }
    <!-- carousel -->
    <swiper class="m-t-8 m-t-10-s overflow-visible"
      [slidesPerView]="'auto'"
      [freeMode]="true"
      [spaceBetween]="[20, 40, 40, 40][client.sizeId]"
      [centerInsufficientSlides]="true">
      @for (slide of component.slides; track $index; let i = $index) {
        <ng-template swiperSlide
          class="p-b">
          <fashion-recommendations-slide [slideData]="slide"
            [selected]="currentIndex === i"
          (slideSelect)="select(i)"></fashion-recommendations-slide>
        </ng-template>
      }
    </swiper>
    <!-- colour recomendations -->
    <div class="m-t-8"
      [zippyHideUp]="['fashion-recommendations', 'carousel']">
      <swiper [effect]="'fade'"
        [fadeEffect]="{ crossFade: true }"
        [allowTouchMove]="false"
        (afterInit)="onAfterInit($event)">
        @for (slide of component.slides; track $index; let i = $index) {
          <ng-template swiperSlide>
            <div class="bg-col-w center">
              <h3 class="h3">{{ 'Recommended for %' | translate : slide.slideTitle }}</h3>
              <div class="grid flex flex-justify-center flex-justify-left-s flex-wrap m-t-6">
                @for (colour of slide.colourSwatches; track $index) {
                  <fashion-recommendations-colour class="m-t-5"
                  [colourData]="colour"></fashion-recommendations-colour>
                }
              </div>
            </div>
          </ng-template>
        }
      </swiper>
    </div>
  </div>
}